import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import iroImg from '../assets/images/b2bDirectCall/HeroB2BDirectCall.jpg';

const GlassPopup = ({
  isOpen,
  onClose,
  imageAlt,
  maxWidth = "900px",
  buttonLink = "/ourservices/b2bdirectcall"
}) => {
  const isIta = useSelector((state) => state.createUser.languageIta);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && onClose) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEsc);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "auto";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="glass-popup-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="B2B Direct Call popup"
    >
      <div
        className="glass-popup-container responsive-popup"
        style={{ maxWidth }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="glass-popup-close"
          onClick={onClose}
          aria-label={isIta ? "Chiudi popup" : "Close popup"}
          type="button"
        >
          ×
        </button>

        <div className="glass-popup-image-wrapper">
          <img
            src={iroImg}
            alt={imageAlt || "B2B Direct Call"}
            className="glass-popup-image"
          />

          <div className="glass-popup-content">
            <div className="glass-popup-content-inner">
              <h2>
                {isIta ? "B2B Direct Call" : "B2B Direct Call"}
              </h2>

              <p>
                {isIta
                  ? "Raggiungi distributori selezionati nei mercati di tuo interesse attraverso un servizio di outreach diretto, professionale e orientato al risultato."
                  : "Reach selected distributors in your target markets through a direct, professional and results-oriented outreach service."}
              </p>
            </div>

            <a href={buttonLink} className="glass-popup-button" onClick={onClose}>
              {isIta ? "Scopri di più" : "Discover more"}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlassPopup;